<app-shared-search [resolver]="resolver" [searchOptions]="searchOptions$ | async" (search)="onSearch($event)">
  <h1 search-header class="d-inline-block align-middle m-0">
    {{ 'SEARCH_PAGE_HINT' | translate }}
  </h1>

  <app-search-results
    search-results
    [isSearchActive]="isSearchActive"
    [isAuthenticated]="isAuthenticated$ | async"
    [isLoading]="isLoading$ | async"
    [options]="searchOptions$ | async"
    [searchState]="resolver.state"
    [results]="results$ | async"
    (pageChanged)="resolver.onPageChanged($event)"
    (sortCategory)="setSortCategory($event)"
  ></app-search-results>
</app-shared-search>
